import { render, staticRenderFns } from "./pondAdd.vue?vue&type=template&id=344c365e&scoped=true&"
import script from "./pondAdd.vue?vue&type=script&lang=js&"
export * from "./pondAdd.vue?vue&type=script&lang=js&"
import style0 from "./pondAdd.vue?vue&type=style&index=0&id=344c365e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344c365e",
  null
  
)

export default component.exports